import { useCallback, useMemo, useState, useEffect } from 'react';
import betterDocsAiimg from './assets/betterDocsAiimg.svg';

export function AiChatbotCard({
	index,
	id,
	cartData,
	addToCart,
	removeFromCart,
}) {
	const betterDocsAI = useMemo(() => {
		if (!cartData) {
			return null;
		}

		const _cartData = cartData.details.map((i, idx) => ({
			...i,
			index: idx,
		}));

		return _cartData?.find(item => +item.id === +id) ?? null;
	}, [cartData]);

	const [priceId, setPriceId] = useState(1);
	const [typeYearly, setTypeYearly] = useState(1);
	const [checked, setChecked] = useState(betterDocsAI ? true : false);

	useEffect(() => {
		let priceId = betterDocsAI?.item_number?.options?.price_id;
		if (betterDocsAI && priceId) {
			setTypeYearly(+priceId);
			setPriceId(+priceId);
		}
	}, [betterDocsAI]);

	const addProductInCart = useCallback(
		(priceId, action = false) => {
			let product = {
				download_id: id,
				price_id: priceId,
			};

			if (action) {
				product.action = 'update';
			}

			addToCart(product, true, false);
		},
		[addToCart]
	);

	useEffect(() => {
		if (checked && betterDocsAI === null) {
			addProductInCart(typeYearly);
		} else if (!checked && betterDocsAI && betterDocsAI?.index) {
			removeFromCart(betterDocsAI?.index);
		}
	}, [checked, typeYearly]);

	useEffect(() => {
		if (betterDocsAI && typeYearly !== +priceId) {
			addProductInCart(typeYearly, true);
		}
	}, [typeYearly, betterDocsAI]);

	useEffect(() => {
		if (betterDocsAI == null) {
			setChecked(false);
		}
	}, [betterDocsAI]);

	return (
		<>
			<form>
				<label
					htmlFor={`addToItemAi` + index}
					className="wp-checkout-flex wp-checkout-flex-space-between wp-checkout-aiCard "
				>
					<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-card-left-content">
						<div className="wp-checkout-aiCard-add">
							<input
								type="checkbox"
								checked={checked}
								onChange={() => setChecked(checked => !checked)}
								id={`addToItemAi` + index}
							/>
							<label
								htmlFor={`addToItemAi` + index}
								className="aiCard-add-checkbox"
							></label>
						</div>
						<div className="wp-checkout-aiCard-logo">
							<img src={betterDocsAiimg} />
						</div>
						<div className="wp-checkout-aiCard-header">
							<h3 className="wp-checkout-font-lg aiCard-header">
								BetterDocs AI Chatbot
							</h3>
							<p className="wp-checkout-font-sm aiCard-sub-header">
								{typeYearly === 2
									? 'Yearly Plan'
									: 'Monthly Plan'}
							</p>
						</div>
					</div>
					<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-card-right-content">
						<div className="wp-checkout-flex wp-checkout-flex-center">
							<span className="wp-checkout-font-sm toggle-switch-content">
								mo.
							</span>

							<label className="switch">
								<input
									type="checkbox"
									checked={typeYearly === 2}
									onChange={e =>
										setTypeYearly(e.target.checked ? 2 : 1)
									}
								/>
								<span className="slider round"></span>
							</label>

							<span className="wp-checkout-font-sm toggle-switch-content">
								yr.
							</span>
						</div>

						<h3 className="wp-checkout-font-lg wp-checkout-product-price">
							{typeYearly === 2 ? '$69.00' : '$8.99'}
						</h3>
					</div>
				</label>
			</form>
		</>
	);
}
